module.exports = __webpack_public_path__ + "static/part-2-8869c2e065a6ae187c633a378e6fa6be.svg";